import React from 'react';
import edit from '../../assets/icons/new_icon/edit-white.svg';

interface UbbeCardHeaderProps {
  onClick?: any;
  headerText: string;
  editable?: boolean;
  otherOption?: any;
  otherOptionFunction?: any;
}
const UbbeCardHeader = ({
  onClick,
  headerText,
  editable,
  otherOption,
  otherOptionFunction,
}: UbbeCardHeaderProps) => {
  return (
    <div className='ubbe-card-header d-flex justify-content-between'>
      <h5 className='ps-3 mb-0 GlobalBoxHead'>{headerText}</h5>
      {editable ? (
        <div
          className='my-auto'
          style={{ paddingRight: '20px' }}
        >
          {otherOption && (
            <span
              className='btn-ubbe-no-style'
              onClick={otherOptionFunction && otherOptionFunction}
            >
              <u
                className='labelText'
                style={{
                  color: 'white',
                  fontSize: '16px',
                  cursor: 'pointer',
                  fontWeight: '400',
                  marginRight: '10px',
                }}
              >
                {' '}
                {otherOption}
              </u>
            </span>
          )}
          <button
            type='button'
            className='editwhiteBg'
            onClick={onClick}
          >
            <img
              src={edit}
              alt={edit}
            />
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default UbbeCardHeader;
